import { type FC } from 'react';
import { Typography, Tooltip } from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';
import i18n from '@shared/config/i18n';
import * as Styled from './styled';
import type { Props } from './types';

export const DetailToolbarHeader: FC<Props> = ({ title, onClose, isLoading = false }) => (
  <Styled.Wrapper>
    {!isLoading && (
      <Typography variant="h6" noWrap>
        {title}
      </Typography>
    )}
    {onClose && (
      <Tooltip title={i18n.t('close')}>
        <Styled.Button onClick={onClose}>
          <CloseOutlined />
        </Styled.Button>
      </Tooltip>
    )}
  </Styled.Wrapper>
);
